export default "/_next/static/images/d71a027e6909c835b677875118e293ea.svg";